import Vue from 'vue'
import { plugin as EqualHeights } from '@morev/equal-heights/dist/vue.cjs'

Vue.use(EqualHeights)
